import React from "react";

const head = {
  heading: "Welcome Home, Alumni!",
  description:"Welcome to Alumni Connect App—your alumni hub. Join us now for community, resources, and opportunities."
}

const cardArr = [
  {
    "name": "Seamless Networking",
    "description": "Reconnect effortlessly with classmates and professors, expanding your network across classes, industries, and regions.",
    "link": "Try Seamless Networking",
    "image": "./assets/tailored_communication_channels.webp"
  },
  {
    "name": "Exclusive Events & Reunions",
    "description": "Access a comprehensive event calendar, and receive personalised event recommendations—all at your fingertips with Alumni Connect App.",
    "link": "Try Exclusive Events & Reunions",
    "image": "./assets/dynamic_event_management.webp"
  },
  {
    "name": "Career Advancement",
    "description": "Explore job postings, connect with mentors, and access career workshops through Alumni Connect.",
    "link": "Try Career Advancement",
    "image": "./assets/career.png"
  },
  {
    "name": "Celebrate Achievements",
    "description": "Share your success stories, receive recognition, and inspire others with Alumni Connect.",
    "link": "Try Celebrate Achievements",
    "image": "./assets/achievements.png"
  },
  {
    "name": "Stay Connected",
    "description": "Stay informed with alma mater news, access alumni profiles effortlessly, and stay connected with updates through the Alumni Connect App.",
    "link": "Try Stay Connected",
    "image": "./assets/stayconnected.png"
  },
  {
    "name": "Easy Access",
    "description": "Experience ultimate convenience with the Alumni Connect App: access it anytime, anywhere.",
    "link": "Try Easy Access",
    "image": "./assets/easy_access.png"
  }
]
const UsecaseComp = () => {
  return (
    <div className="usecase_comp" id="doctors">
      <div className="container">
        <div className="comp_header">
          <h1>{head?.heading}</h1>
          <p>
            {head?.description}
          </p>
        </div>
        <div className="usecases_wrapper">
          {cardArr?.map((card, idx) => (
            <div className="case_card">
              <div className="icon">
                {/* <img src={`/assets/${card?.name}.png`} alt="" /> */}
                <img src={card?.image} alt="" />
              </div>
              <div className="details">
                <h4>{card?.name}</h4>
                <p>{card?.description}</p>
                <a href="">
                  {card?.link}{" "}
                  <i class="fa-solid fa-arrow-right-long"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default UsecaseComp;
